import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const SatoshiContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${SPACING._20};
  width: 100%;
  height: 100%;
  gap: ${SPACING._16};
`;

export const BarContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: ${SPACING._4};

  span {
    white-space: nowrap;
  }
`;

export const SatoshiHeader = styled.header<{
  visible: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${SPACING._16};
  text-align: center;
  transition: 200ms;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  pointer-events: ${({ visible }) => (visible ? 'all' : 'none')};
`;

export const SatoshiBody = styled.div`
  position: relative;
  overflow-y: auto;
  scrollbar-width: thin;
`;

export const SatoshiFooter = styled.footer<{
  visible: boolean;
}>`
  margin-top: auto;
  display: flex;
  flex-direction: row;
  gap: ${SPACING._8};
  transition: 200ms;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  pointer-events: ${({ visible }) => (visible ? 'all' : 'none')};
`;
